import { render, staticRenderFns } from "./ContentFeedGallery.vue?vue&type=template&id=09e8b8a4&scoped=true&"
import script from "./ContentFeedGallery.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedGallery.vue?vue&type=style&index=0&id=09e8b8a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e8b8a4",
  null
  
)

export default component.exports